<template>
  <ShortcutPage :release="release"></ShortcutPage>
</template>
<script>
import ShortcutPage from './ShortcutPage'

export default {
  name: 'Celeritas',
  data: function() {
    return { release: null }
  },
  components: {
    ShortcutPage,
  },
  mounted: function () {
    this.release = {
      img: '/img/single-celeritas.jpg',
      name: 'Celeritas',
      type: 'single',
      links: [
        {
          service: 'bandcamp',
          url: 'https://grizzlycogs.bandcamp.com/track/celeritas-single',
          btnLabel: 'Listen'
        },
        {
          service: 'spotify',
          url: 'https://open.spotify.com/intl-fr/album/36pCYxvqzfyc336OOMy7yS?si=ma7TWstfSEWj6errux-y0g',
          btnLabel: 'Listen'
        },
        {
          service: 'youtube',
          url: 'https://www.youtube.com/watch?v=lx3MLABYC6w',
          btnLabel: 'Listen'
        },
        {
          service: 'deezer',
          url: 'https://link.deezer.com/s/32hanFYNcRy7GN6VXdDgF',
          btnLabel: 'Listen'
        },
        {
          service: 'apple',
          url: 'https://music.apple.com/fr/album/celeritas-single/1871841885',
          btnLabel: 'Listen'
        },
        {
          service: 'amazon',
          url: 'https://amazon.fr/music/player/albums/B0GJKKVMT9?marketplaceId=A13V1IB3VIYZZH&musicTerritory=FR&ref=dm_sh_ZLCa1ZIpqx8Wh1Ozcmsqqya5c',
          btnLabel: 'Buy'
        },
        {
          service: 'tidal',
          url: 'https://tidal.com/album/492477375',
          btnLabel: 'Listen'
        }
      ]
    }
  }
}
</script>